import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../lib/api';
import { TimedAttempt, type TimedAttemptData } from '../components/TimedAttempt';
import { CoachingAttempt, type CoachingAttemptData } from '../components/CoachingAttempt';

type AttemptData =
  | (TimedAttemptData & { mode: 'timed' })
  | (CoachingAttemptData & { mode: 'coaching' });

export function TakeAttempt() {
  const { id } = useParams<{ id: string }>();
  const [data, setData] = useState<AttemptData | null>(null);

  useEffect(() => {
    if (!id) return;
    api.get<AttemptData>(`/api/take/attempt/${id}`).then(setData);
  }, [id]);

  if (!data) return <p className="loading">Loading attempt…</p>;
  if (data.mode === 'coaching') return <CoachingAttempt initial={data} />;
  return <TimedAttempt initial={data} />;
}
